import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const ActionTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`
